import { useState } from 'react';
import RouterImage from './RouterImage';
import { P2GImage, P2GCdnImage } from '@parcel2go/core-ui';

interface props {
  src: string;
  alt: string;
  style?: any;
}

export default function P2GConditionalImage(props: props) {
  const [imgError, setImgError] = useState<boolean>(false);
  if (!props.src || imgError) {
    return null;
  }
  if (props.src?.startsWith('http')) {
    return <P2GImage alt={props.alt} src={props.src} style={props.style} onError={() => setImgError(true)} />;
  }
  if (props.src?.startsWith('/~/')) {
    return <RouterImage alt={props.alt} src={props.src} style={props.style} onError={() => setImgError(true)} />;
  }
  return <P2GCdnImage alt={props.alt} src={props.src} style={props.style} onError={() => setImgError(true)} />;
}
